import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {Bar, defaults} from 'react-chartjs-2';

defaults.global.defaultFontStyle = 'normal';
defaults.global.defaultFontFamily = "'Barlow', sans-serif";

export function IncomeAndExpenses(props) {


const dashboard = useSelector(state => state.dashboard.dashboard);

// initiate which dataset is graphed ($/month or invoices/month)
const [currentDataSets, setCurrentDataSets] = useState('money');

const [xLabels, setXLabels] = useState(null);
const [data, setData] = useState({
    expenseCount: null,
    expenseValue: null,
    incomeCount: null,
    incomeValue: null,
    netIncome: null
})

useEffect(() => {
    // when billing data updates, create arrays of data for use in datasets
    let incoming_count = dashboard.billing_data.map((item) => item.incoming_count);
    let incoming_value = dashboard.billing_data.map((item) => -1*(parseFloat(item.incoming_value).toFixed(2)));
    let outgoing_count = dashboard.billing_data.map((item) => item.outgoing_count);
    let outgoing_value = dashboard.billing_data.map((item) => parseFloat(item.outgoing_value).toFixed(2));
    let net_income = dashboard.billing_data.map((item) => parseFloat(item.outgoing_value).toFixed(2) - parseFloat(item.incoming_value).toFixed(2));
    let labels = dashboard.billing_data.map((item) => item.month);
    setData({
        ...data,
        expenseCount: incoming_count,
        expenseValue: incoming_value,
        incomeCount: outgoing_count,
        incomeValue: outgoing_value,
        netIncome: net_income
    })
    setXLabels(labels)
}, [dashboard.billing_data]);

// toggle which dataset is graphed ($/month or invoices/month)
const handleDataSet = (id) => {
    setCurrentDataSets(id);
}

const dataSets = {
    money: [
        {
            label: "Net Income",
            type: "line",
            data: data.netIncome,
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: "#247607",
            borderWidth: 2,
        },
        {
            label: "Revenue",
            // yAxisID: 'Money',
            type: "bar",
            data: data.incomeValue,
            backgroundColor: "#9dd28b",
            borderColor: 'rgba(255, 255, 255, 0)',
            borderWidth: 0,
        },
        {
            label: "Expenses",
            // yAxisID: 'Money',
            type: "bar",
            data: data.expenseValue,
            backgroundColor: "#f38e73",
            borderColor: 'rgba(255, 255, 255, 0)',
            borderWidth: 0,
        },

    ],
    num: [
        {
            label: "Incoming Invoices",
            // yAxisID: 'Num',
            type: "bar",
            data: data.expenseCount,
            backgroundColor: "#FCC3B8",
            // backgroundColor: "#EA785F",
            borderColor: 'rgba(255, 255, 255, 0)',
            borderWidth: 0,
        },
        {
            label: "Outgoing Invoices",
            // yAxisID: 'Num',
            type: "bar",
            data: data.incomeCount,
            backgroundColor: "#A1A8FC",
            // backgroundColor: "#4754FF",
            borderColor: 'rgba(255, 255, 255, 0)',
            borderWidth: 0,
        }
    ]
}

    return (

        <div className="w charts-wrapper" >
            <h3 className="title2 gap-below-m">Income & Expenses</h3>
            <div>
                <div className={"typical-radio " + (currentDataSets === "money" ? "checked" : "")} onClick={() => handleDataSet("money")} >
                    <input type="radio" id="money" name="billingDataSet" value="money" onChange={() => handleDataSet("money")} checked={currentDataSets === "money"}/>
                    <label className="content2" htmlFor="rejected">Value</label>
                </div>
                <div className={"typical-radio gap-below-m " + (currentDataSets === "num" ? "checked" : "")}  onClick={() => handleDataSet("num")} >
                    <input type="radio" id="num" name="billingDataSet" value="num" onChange={() => handleDataSet("num")} checked={currentDataSets === "num"}/>
                    <label className="content2" htmlFor="rejected">Quantity</label>
                </div>
            </div>
            <div className="barchart chart-wrapper" >
                <Bar
                    data={{
                        labels: xLabels,
                        datasets: dataSets[currentDataSets]
                    }}
                    options={{
                        maintainAspectRatio: false,
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                title: {
                                    display: true,
                                    text: 'Chart with Title Configuration'
                                },
                                gridLines: {
                                    color: "#DFDFE2",
                                    lineWidth: 1,
                                    zeroLineColor: "#3C3B41",
                                    drawTicks: true,
                                    tickMarkLength: 3
                                },
                                ticks: {
                                    fontSize: 12,
                                    padding: 8, // space between axis tick label and axis
                                    fontColor: "#3C3B41",
                                    // Include a dollar sign in the ticks
                                    callback: function(value, index, values) {
                                        if (currentDataSets === "money") {
                                            if (value < 0) {
                                                return "- $" + ((-1)*value).toFixed(2);
                                            } else {
                                                return "$" + value.toFixed(2);
                                            }
                                        } else return value
                                    },
                                },
                            }
                            ],
                            xAxes: [{
                                gridLines: {
                                    display: false,
                                },
                                ticks: {
                                    fontSize: 12,
                                    fontStyle: "bold",
                                    fontColor: "#919197",
                                }
                            }],
                        },
                        legend: {
                            position: "bottom",
                            align: "start", 
                            boxWidth: 16,
                            labels: {
                                usePointStyle: true,
                                fontSize: 14,
                                fontStyle: "normal",
                                boxWidth: 12,
                                fontColor: "#3C3B41",
                                padding: 30,
                            }
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItems, data) {
                                    const label = data.datasets[tooltipItems.datasetIndex].label;  
                                    if (currentDataSets === "money") {  
                                        if (tooltipItems.yLabel < 0) {
                                            return "- $" + ((-1)*tooltipItems.yLabel).toFixed(2) + " " + label;
                                        } else {
                                            return "$" + tooltipItems.yLabel.toFixed(2) + " " + label;
                                        }
                                    } else if (tooltipItems.yLabel === 1) {
                                        return tooltipItems.yLabel + " " + label.slice(0, -1)
                                    } else return tooltipItems.yLabel + " " + label;
                                }
                            }
                        }
                    }}
                />
            </div>              
        </div>

    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(IncomeAndExpenses);



